export enum IrisIconButtonTypes {
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}
